/// <reference path="../../app.definition.ts" />




var SockJS, Stomp;

import * as angular from "angular";
import * as _ from "lodash";
import { IStateService } from "angular-ui-router";
import {IServiceManager} from "@common/service/serviceManager";

import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { ConfigService } from "@common/service/config.service";
import { IFeedService } from "@common/service/feed.service";
import { ISubjectService } from "@common/service/subject.service";
import { Subject, TeamTypeEnum } from "@common/model/subject";
import { ICachingService } from "@common/service/caching.service";
import { IDocumentFolderService } from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import { IDocumentService } from "@common/service/document.service";
import { FormService } from "@common/service/form.service";
import { IBroadcastService } from "@common/service/broadcast.service";
import { Discussion } from "@common/model/discussion";
import { PostTypeEnums } from "@common/model/_adocument";
import { Util } from "@common/util";
import { SnackbarService } from "./snackbar.service";
import { IAppRootScopeService } from "@/app/app.definition";
import { FOLDER_MODULES, TOAST_STATUS, UPL_TOASTID_PREFIX } from "@common/model/constants";


export const PNS_ACTION_TYPES = {
    CLEAR_ALL: 'Clear all',
    SHARED_FLDR_OPND: 'Shared Folder opened',
    ENTITY_ACTION: 'Action on entity'
};
export class PushNotificationService {
    markNotificationAsRead: Function;
    updateFeeds: Function;
    addNotificationToCache: Function;
    currentUser: any;
    subscription: any;
    processNotification: Function;
    openEntity;
    updateTotalCnt: Function;
    deleteDocumentNotification: Function;
    deleteFormNotifications: Function;
    dltNtfctnsOnFrmDlt: Function;
    markNotificationAsDeleted: Function;
    markAllNotificationAsRead: Function;
    markNotificationInCache: Function;

    static $inject = ["CacheService", "$state", "$rootScope", "ApiAdapterService", "ConfigService", "FeedService", "$q", "SubjectService",
        "CachingService", "DocumentFolderService", "DocumentService", "$timeout", "SnackbarService", "FormService", "BroadcastService","ServiceManager","ecareEnv"];
    constructor(
        private CacheService: CacheService,
        private $state: IStateService,
        private $rootScope: IAppRootScopeService,
        private ApiAdapterService: JavaApiAdapterService,
        private ConfigService: ConfigService,
        private FeedService: IFeedService,
        private $q: ng.IQService,
        private SubjectService: ISubjectService,
        private $_caching: ICachingService,
        private DocumentFolderService: IDocumentFolderService,
        private $_document: IDocumentService,
        private $timeout: ng.ITimeoutService,
        private $_snack: SnackbarService,
        private FormService: FormService,
        private BroadcastService: IBroadcastService,
        private ServiceManager: IServiceManager,
        private ecareEnv: string
    ) {
        var sendDesktopNotification = (notification) => {
            const ecvLogoUrl = `https://assets.ecarevault.com/${this.ecareEnv}/src/client/assets/images/ecv_logo_wo_text.png`;
            var isWindowActive = document.hasFocus();
            // 'Notification' in window is required for ie as it can not identify !!Notification
            if ('Notification' in window) {
                if (Notification.permission == "granted" && !isWindowActive && !!notification.mobilePushMessage) {
                    let dNotifiaction = new Notification('eCareVault', {
                        icon: ecvLogoUrl,
                        body: notification.mobilePushMessage
                    });
                    let winLocation = window.location.origin + "/#/ecare-vault/login?rtype=dnotification&id=" + notification.id + "&uId=" + this.currentUser.id;
                    var currentWindow = window;
                    dNotifiaction.onclick = () => {
                        if (!!currentWindow && !currentWindow.closed) {
                            currentWindow.focus();
                            this.openEntity(notification);
                        } else {
                            var tab = window.open(winLocation, "_blank");
                            tab.alert(winLocation);
                        }
                    };
                    $timeout(dNotifiaction.close.bind(dNotifiaction), 10000);
                } else {
                    console.log('Desktop Notification has not been sent=================');
                    console.log("Support => ", !!Notification);
                    console.log("Permission => ", Notification.permission);
                    console.log("Is Window Active => ", isWindowActive);
                    console.log("Is Silent => ", notification.silent);
                }
            }
        };

        this.updateTotalCnt = (fct) => {
            let totalCnt;
            if (!fct) {
                totalCnt = fct;
            } else {
                totalCnt = CacheService.getTotalNotifications() + fct;
            }
            CacheService.setTotalNotifications(totalCnt);
        }

        this.addNotificationToCache = (notification) => {
            //Push the notification to the bell only if its not silent and not disabled
            if (!notification.silent && !notification.isDisabled) {
                let updtCnt = false;
                var pushNotifications = CacheService.getPushNotifications();
                if (!!pushNotifications) {
                    let ind = pushNotifications.findIndex(n => n.id == notification.id);
                    if (ind == -1) {
                        pushNotifications.unshift(notification);
                        updtCnt = true;
                    }
                } else {
                    pushNotifications = [];
                    pushNotifications.unshift(notification);
                    updtCnt = true;
                }
                CacheService.setPushNotifications(pushNotifications);
                updtCnt && (this.updateTotalCnt(1)); //Update the count only if new notifications have been added
                BroadcastService.broadcast('update-notifications');
                BroadcastService.broadcast('update-notification-panel', [notification]);
            }
            //Send desktop notification if its not silent
            if (!notification.silent) {
                sendDesktopNotification(notification);
            }
        }

        this.processNotification = (newNotification: any): any => {

            var deferred = $q.defer();
            var context = this;
            this.currentUser = CacheService.getUser();
            try {
                if (newNotification.status == "FAIL" && newNotification.event != "SHARE") {
                    context.addNotificationToCache(newNotification);
                    if (_.includes(["DOCUMENT", "LINK"], newNotification.entity)) {
                        FeedService.updateFeedInLocalCache([{ id: newNotification.entityId }], "documents", true, true)
                            .then((s) => {
                                FeedService.updateFeedInLocalCache([{ id: newNotification.entityId }], "posts", true, true)
                                    .then((s) => {
                                        // Update the document upload toastr to failed status
                                        let toastClass = '.' + UPL_TOASTID_PREFIX + newNotification.entityId;
                                        let errorElem = $(toastClass).find('#progress-error-txt');
                                        $(errorElem).empty();
                                        $(errorElem).append(newNotification.mobilePushMessage);
                                        $(toastClass).removeClass(TOAST_STATUS.PROCESSING);
                                        $(toastClass).addClass(TOAST_STATUS.FAILED);
                                        ///////////////////
                                        BroadcastService.broadcast('document-failed', [newNotification.entityId]);
                                        deferred.resolve();
                                    });
                            });
                    } else {
                        deferred.resolve();
                    }
                }
                else if (newNotification.event == "UPDATE_VAULT") {
                    context.addNotificationToCache(newNotification);
                    const notiPgsz = newNotification.additionalProperties.notifications;
                    //Fetch latest notications only if user notifications are enabled and additionalProperties.notifications count is available
                    if (!!notiPgsz) {
                        ApiAdapterService.fetchNotifications(CacheService.getPassword(), 0, notiPgsz).then((n) => {
                            n.notifications.reverse();
                            n.notifications.forEach(noti => context.addNotificationToCache(noti));
                        });
                    }
                    let currSubject = CacheService.getCurrentSubject();
                    let updateFeed = (!newNotification.subjectId || !currSubject || currSubject.subjectId == newNotification.subjectId);
                    BroadcastService.broadcast('post-and-feeds-updates', [updateFeed]);
                    //Reset feeds if user is not on carefeed page
                    if ($state.current.name != 'parent-carefeed') {
                        $_caching.resetCachedFeeds();
                    }
                    deferred.resolve();
                }
                else if (newNotification.entity == "TEAM_INVITATION") {
                    //to enable-disable document share set the co-captain flag in the subject cache
                    if (newNotification.event == "PROMOTE-CO-CAPTAIN" || newNotification.event == "DEMOTE-CO-CAPTAIN") {
                        var isCoCaptain = true;
                        if (newNotification.event == "PROMOTE-CO-CAPTAIN") {
                            context.addNotificationToCache(newNotification);
                        } else if (newNotification.event == "DEMOTE-CO-CAPTAIN") {
                            isCoCaptain = false;
                        }
                        var input = {
                            'coCaptain': isCoCaptain
                        }
                        SubjectService.updateSubject(newNotification.subjectId, input);
                        BroadcastService.broadcast('update-team', [newNotification.subjectId, isCoCaptain]);
                        BroadcastService.broadcast('update-context-menu', [null, newNotification.subjectId]);
                        BroadcastService.broadcast('update-team-card', [newNotification.subjectId]);
                        BroadcastService.broadcast('team-updates', [newNotification.subjectId, 'CO-CAPTAIN']);
                        deferred.resolve();

                    } else if (newNotification.event == "ACCEPT_INVITE") {
                        BroadcastService.broadcast('update-member-list', [newNotification.subjectId]);
                        let mem = {
                            'id': newNotification.currentUserId,
                            'isFormerTeamMember': false,
                            'isActive': true
                        };
                        //Update doc users in cache
                        $_caching.updateDocumentUserInCache(newNotification.subjectId, mem);
                        //Update doc users on docs/disc/carefeed page
                        BroadcastService.broadcast('doc-user-updates', [newNotification.subjectId, mem]);
                        context.addNotificationToCache(newNotification);
                        deferred.resolve();
                    } else {
                        context.addNotificationToCache(newNotification);
                        deferred.resolve();
                    }
                }
                else if (_.includes(["TEAM_MEMBER", "ORG"], newNotification.entity)) {
                    var isOrg = (newNotification.entity == "ORG");
                    if (newNotification.event == "DELETE") {
                        if ((isOrg && newNotification.entityId == this.currentUser.organizationId) || (!isOrg && newNotification.entityId == this.currentUser.id)) {
                            //Reset the bell notifications
                            BroadcastService.broadcast('reset-notifications');
                            //delete the notification related to this teamMember/Org from the notification-panel.
                            BroadcastService.broadcast('mark-notification-deleted');
                            //Clear the notifications from bottom tray as well
                            $_snack.removeSnackbar('subj-' + newNotification.subjectId);

                            var toastId = "del-member-" + newNotification.id;
                            var onclickFunc = function () {
                                $_snack.cleanup(toastId);
                                $rootScope.logout();
                            }
                            SubjectService.getSubjectById(newNotification.subjectId).then(sub => {
                                var input = {
                                    'isFormerTeamMember': true
                                }
                                SubjectService.updateSubject(newNotification.subjectId, input);
                                var subjType = sub.fullName;
                                if (sub.subjectTypeId == "INDIVIDUAL") {
                                    subjType = sub.firstName + " " + sub.lastName.charAt(0).toUpperCase() + "'s Team";
                                }
                                let msg = Util.EXIT_TEAM_TOASTR.replace('$subject', subjType);
                                if (isOrg) {
                                    msg = newNotification.message + "<br />Click here to log out and refresh the application to view the changes.";
                                }
                                $_snack.showInvitationToastr({
                                    message: msg,
                                    notificationId: toastId
                                }, onclickFunc);
                            });
                        }
                    }
                    context.addNotificationToCache(newNotification);
                    deferred.resolve();
                }
                else if (newNotification.entity == "TEAM") {
                    var processNoti = function (refresh) {
                        if (newNotification.subjectId != null) {
                            SubjectService.getSubjectById(newNotification.subjectId).then(subject => {
                                // this refreshes the list so required everytime
                                refresh && (BroadcastService.broadcast('add-new-team', [subject.teamPartyParentId]));

                                let toastId = "team-" + newNotification.subjectId;
                                var msg = newNotification.message;
                                if (newNotification.event == "ON_BEHALF_OF") {
                                    //In case of team created on-behalf-of,
                                    //mark bell notification as read on click of tray notification
                                    var onclickFunc = function () {
                                        let func = function (n) {
                                            return n.id != newNotification.id
                                        }
                                        context.markNotificationAsRead(func, newNotification);
                                        $_snack.cleanup(toastId);
                                        $rootScope.selectChild(subject).then((success) => {
                                            $state.go('parent-dashboard', { team: newNotification.subjectId }, { reload: true });
                                        });
                                    }
                                } else {
                                    let rplTxt;
                                    if (subject.subjectTypeId == TeamTypeEnum.CARE_RECIEPIENT) {
                                        rplTxt = subject.firstName + " " + subject.lastName;
                                    } else {
                                        rplTxt = subject.projectName;
                                    }
                                    let suffix = (newNotification.event == "CREATE") ? Util.ACCEPT_INVITATION_POPUP : Util.SELECT_VIEW_MSG;
                                    msg = msg.replace(rplTxt, Util.truncateLongText(rplTxt, 30)) + suffix;
                                    var onclickFunc = function () {
                                        $_snack.cleanup(toastId);
                                        $rootScope.selectChild(subject).then((success) => {
                                            $state.go('parent-dashboard', { team: newNotification.subjectId }, { reload: true });
                                        });
                                    }
                                }
                                $_snack.showInvitationToastr({ message: msg, notificationId: toastId }, onclickFunc);
                                context.addNotificationToCache(newNotification);
                                deferred.resolve();
                            });
                        } else {
                            let toastId = "team-" + newNotification.id;
                            var onclickFunc = function () {
                                $_snack.cleanup(toastId);
                            }
                            $_snack.showInvitationToastr({ message: newNotification.message, notificationId: toastId }, onclickFunc);
                            context.addNotificationToCache(newNotification);
                            deferred.resolve();
                        }

                    }
                    if (newNotification.event == "CREATE" || newNotification.event == "ON_BEHALF_OF" || (newNotification.event == "TEAM_FROZEN" && newNotification.currentUserId != newNotification.userId)) {
                        CacheService.setSortedSubjects([]);
                        SubjectService.getSubjectsPgWise(0).then(data => {
                            BroadcastService.broadcast('refresh-teams-drpdn');
                            processNoti(true);
                        });
                    } else {
                        processNoti(false);
                    }

                }
                else if (newNotification.entity == "FORM-SUBMITTED") {
                    FormService.handleFormSubmittedToMe();
                    context.addNotificationToCache(newNotification);
                    BroadcastService.broadcast('update-refresh-icon');
                    deferred.resolve();
                }
                else if (newNotification.entity == "FORM-ASSIGNED" ||
                    newNotification.entity == "FORM-REASSIGNED" ||
                    newNotification.entity == "FORM" ||
                    newNotification.entity == "SERVICENOTE" ||
                    newNotification.entity == "SERVICE") {
                    //TODO : change as this also executed for service also.
                    BroadcastService.broadcast('update-refresh-icon');
                    context.addNotificationToCache(newNotification);
                    if (newNotification.entity == "FORM" && newNotification.event == 'UNASSIGN') {
                        //If current user is loggedIn then update the bell notifications.
                        let deleteEntities = ['FORM-ASSIGNED', 'FORM-REASSIGNED', 'FORM-WORKFLOW'];
                        var func = function (n) {
                            return !deleteEntities.includes(n.entity) || n.entityId != newNotification.entityId
                        }
                        context.markNotificationInCache(func);
                        //Clear the notifications from bottom tray as well
                        $_snack.removeSnackbar('entity-' + newNotification.entityId);
                    }
                    deferred.resolve();
                }
                else if (newNotification.entity == "FORM-MOVE") {
                    //silent notification for form migration workflow
                    var additionalProperties = newNotification.additionalProperties;
                    if (!!additionalProperties && additionalProperties.createTeam == false) {
                        CacheService.setSortedSubjects([]);
                        SubjectService.getSubjectsPgWise(0).then(data => {
                            BroadcastService.broadcast('refresh-teams-drpdn');
                            BroadcastService.broadcast('add-new-team');
                        });
                    }
                    this.deleteFormNotifications(newNotification.entityId);
                    deferred.resolve();
                }
                else if (newNotification.entity == "FORM-DELETED") {
                    context.addNotificationToCache(newNotification);
                    context.dltNtfctnsOnFrmDlt(newNotification.entityId);
                    BroadcastService.broadcast('update-refresh-icon');
                    deferred.resolve();
                }
                else if (newNotification.entity == "FORM-SUBMITTED-TRAY") {
                    var additionalProperties = newNotification.additionalProperties;
                    var fn, module, tstId;

                    if (newNotification.event == 'REDIRECT') {
                        module = 'forms';
                        tstId = module + '-' + newNotification.id;
                        fn = function () {
                            $_snack.cleanup(tstId);
                            FormService.manageForms('availableForms', +newNotification.subjectId, true);
                        }
                    } else if (newNotification.event == 'FORM-REVIEW') {
                        module = 'forms';
                        tstId = module + '-' + newNotification.id;
                        fn = function () {
                            $_snack.cleanup(tstId);
                            SubjectService.getSubjectById(newNotification.subjectId).then(subject => {
                                $rootScope.selectChild(subject).then((success) => {
                                    FormService.viewForm(0, newNotification.entityId, 'cmpf', null, true);                                });
                            })
                        }
                    } else {
                        module = 'analytics';
                        tstId = module + '-' + newNotification.id;
                        fn = function () {
                            $_snack.cleanup(tstId);
                            $state.go('view-report', { reportData: btoa(JSON.stringify(additionalProperties)) });
                        }
                    }

                    $_snack.addSnackbarItem(module, {
                        message: '<div class="subj-' + newNotification.subjectId + ' entity-' + newNotification.entityId + '" id="' + tstId + '">' + newNotification.message + '</div>',
                        notificationId: tstId
                    }, fn);

                    context.addNotificationToCache(newNotification);
                    deferred.resolve();
                }
                else if (newNotification.entity == "FORM-WORKFLOW") {
                    var additionalProperties = newNotification.additionalProperties;
                    var fn;
                    let subId = newNotification.subjectId;
                    let module = 'workflow', tstId = module + '-' + newNotification.id;
                    let msg = '<div class="subj-' + newNotification.subjectId + ' entity-' + newNotification.entityId + '" id="' + tstId + '">' + newNotification.message + '</div>';


                    if (newNotification.event == 'BEGIN_DETERMINATION') {
                        fn = function () {
                            $_snack.cleanup(tstId);
                            SubjectService.getSubjectById(subId).then(subject => {
                                $rootScope.selectChild(subject).then((success) => {
                                    if (!!additionalProperties && additionalProperties.crntUserProvider) {
                                        FormService.fillForm(newNotification.entityId, 'asf', null, true);
                                    } else {
                                        FormService.viewForm(newNotification.entityId, 0, 'asfr', null, true);
                                    }
                                });
                            });
                        }
                    } else if (newNotification.event == 'ASSIGN_SERVICE') {
                        if (!!additionalProperties && additionalProperties.serviceCreated) {
                            //If service is assigned, then subject data may have been updated so refresh the cache.
                            CacheService.setSortedSubjects([]);
                            let subs = CacheService.getSubjects();
                            let ind = subs.findIndex(sub => sub.subjectId == subId);
                            (ind >= 0) && (subs.splice(ind, 1));
                            SubjectService.getSubjectsPgWise(0).then(data => {
                                BroadcastService.broadcast('refresh-teams-drpdn');
                                BroadcastService.broadcast('add-new-team');
                                let curSub = CacheService.getCurrentSubject();
                                if (!!curSub && curSub.subjectId == subId) {
                                    SubjectService.getSubjectById(subId).then(selSubj => {
                                        CacheService.setCurrentSubject(selSubj);
                                        BroadcastService.broadcast('cr-updated');
                                    });
                                }
                            });
                        }
                        fn = function () {
                            $_snack.cleanup(tstId);
                            SubjectService.getSubjectById(subId).then(subject => {
                                $rootScope.selectChild(subject).then((success) => {
                                    if (!!additionalProperties && additionalProperties.serviceCreated) {
                                        ServiceManager.viewCurrentService(newNotification.entityId,false);
                                    } else {
                                        FormService.viewForm(0, newNotification.entityId, 'cmpf', null, true);
                                    }
                                });
                            });
                        }
                    } else if (newNotification.event == 'WORKFLOW_ERROR') {
                        fn = function () {
                            $_snack.cleanup(tstId);
                            SubjectService.getSubjectById(subId).then(subject => {
                                $rootScope.selectChild(subject).then((success) => {
                                    FormService.viewForm(0, newNotification.entityId, 'cmpf', null, true);
                                });
                            });
                        }
                        msg = '<div class="error-msg subj-' + newNotification.subjectId + ' entity-' + newNotification.entityId + '" id="' + tstId + '">' + newNotification.message + '</div>';
                    }
                    $_snack.addSnackbarItem(module, {
                        message: msg,
                        notificationId: tstId
                    }, fn);
                    context.addNotificationToCache(newNotification);
                    deferred.resolve();
                }
                else if (newNotification.entity == "SIGNATURE" && newNotification.event == 'PENDING') {
                    context.addNotificationToCache(newNotification);
                    deferred.resolve();
                }
                else if (_.includes(["DOCUMENT", "LINK"], newNotification.entity) && newNotification.event == "DELETE") {
                    let nOrgId, docId = newNotification.entityId;
                    BroadcastService.broadcast('update-refresh-icon');
                    //delete the notification related to this document/discussion from the notification-panel.
                    BroadcastService.broadcast('mark-notification-deleted');
                    !!newNotification.additionalProperties && (nOrgId = newNotification.additionalProperties.orgId);
                    if (!!nOrgId && nOrgId == this.currentUser.organizationId) {
                        FeedService.deleteFeed(docId).then((s) => {
                            //delete the notification related to this document/discussion
                            BroadcastService.broadcast('reset-notifications');
                            BroadcastService.broadcast('document-del-updates', [docId]);
                        });
                    }
                    BroadcastService.broadcast('doc-disc-delete-updates', [docId, newNotification.currentUserId, nOrgId]);
                    deferred.resolve();
                } else if (_.includes(["DOCUMENT", "LINK"], newNotification.entity) && newNotification.event == "DOCUMENT_SUMMARY_REGENERATED") {
                    if (newNotification.additionalProperties && newNotification.additionalProperties.status == "SUCCESS") {
                        let module = 'doc';
                        let tstId = module + '-' + newNotification.id;
                        let onClickFunction = function () {
                            $_snack.cleanup(tstId);
                            let documentId = newNotification.entityId;
                            let newSummary = newNotification.additionalProperties.newSummary;
                            let summaryId = newNotification.additionalProperties.documentSummaryId;
                            $state.go('documents-load', {
                                action: 'view-rl-document',
                                stateParams: {
                                    documentId: documentId,
                                    folderId: newNotification.additionalProperties.documentFolderId,
                                    regeneratedSummary: {
                                        documentSummaryId: summaryId,
                                        newSummary: newSummary
                                    }
                                }
                            });
                        }
                        $_snack.addSnackbarItem(module, {
                            message: '<div class=" entity-' + newNotification.entityId + '" id="' + tstId + '">' + newNotification.message + '</div>',
                            notificationId: tstId
                        }, onClickFunction);
                    }
                    else {
                        let module = 'doc-error';
                        let tstId = module + '-' + newNotification.id;
                        let fn = function () {
                            $_snack.cleanup(tstId);
                            let documentId = newNotification.entityId;
                            $state.go('documents-load', {
                                action: 'view-rl-document',
                                stateParams: {
                                    documentId: documentId,
                                    folderId: newNotification.additionalProperties.documentFolderId,
                                    regeneratedSummary: null
                                }
                            });
                        }
                        $_snack.addSnackbarItem(module, {
                            message: '<div class=" entity-' + newNotification.entityId + '" id="' + tstId + '">' + newNotification.message + '</div>',
                            notificationId: tstId
                        }, fn);
                    }
                    context.addNotificationToCache(newNotification);
                    deferred.resolve();
                } else if (newNotification.entity == "DISCUSSION" && newNotification.event == "DELETE") {
                    BroadcastService.broadcast('update-refresh-icon');
                    BroadcastService.broadcast('doc-disc-delete-updates', [newNotification.entityId, newNotification.currentUserId]);
                    deferred.resolve();
                }
                else if (newNotification.entity == "DASHBOARD") {
                    context.addNotificationToCache(newNotification);
                    // This is to refresh the team card whenever we receive a notification about updated team details or submitted forms
                    if (newNotification.event == null || newNotification.event == "UPDATE_TEAM") {
                        BroadcastService.broadcast('update-dashboard-team', [newNotification]);
                    }
                    deferred.resolve();
                }
                else if (newNotification.entity == "USER") {
                    if (newNotification.event == "LOGOUT_USER") {
                        $rootScope.logout();
                        context.addNotificationToCache(newNotification);
                        deferred.resolve();
                    }
                    else if (newNotification.event == "TEAM_ASSIGN") {
                        let module = 'workflow';
                        let tstId = module + '-' + newNotification.id;
                        let fn = function () {
                            $_snack.cleanup(tstId);
                        }
                        $_snack.addSnackbarItem(module, {
                            message: '<div id="' + tstId + '">' + newNotification.message + '</div>',
                            notificationId: tstId
                        }, fn);
                        context.addNotificationToCache(newNotification);
                        deferred.resolve();
                    }
                    else if (newNotification.event == "BULK_ADD_SUCCESS" || newNotification.event == "BULK_ADD_FAILURE") {
                        let module = 'userManagement';
                        let tstId = module + '-' + newNotification.id;
                        let fn = function () {
                            $_snack.cleanup(tstId);
                        }
                        context.addNotificationToCache(newNotification);
                        deferred.resolve();
                    }

                }
                else if (newNotification.event == "CHATBOT_RESPONSE") {
                    BroadcastService.broadcast('chatbot-response-received', [newNotification.additionalProperties]);
                    deferred.resolve();
                } else if (newNotification.event == "SENT_INVITATION") {
                    BroadcastService.broadcast('update-team-invitation-panel-tabs-status', [newNotification]);
                    deferred.resolve();
                }
                else {
                    var folderUpdated = (docMetaData, folderType) => {
                        var date = docMetaData.lastActionTime;
                        if (typeof date == "number") {
                            date = new Date(date);
                        }
                        DocumentFolderService.updateFolderUpdationDate(docMetaData.documentFolderId, date, folderType);
                    };
                    context.updateFeeds(newNotification).then((s) => {
                        context.addNotificationToCache(newNotification);
                        var updatePost = true;  //flag to show newinfo floater on CF page
                        try {
                            if (_.includes(["DOCUMENT"], newNotification.entity) && newNotification.event == "CREATE") {
                                // Update the document upload toastr to complete status
                                let toastClass = '.' + UPL_TOASTID_PREFIX + newNotification.entityId;
                                let toastId = $(toastClass).attr('id');
                                $(toastClass).removeClass(TOAST_STATUS.PROCESSING);
                                $(toastClass).addClass(TOAST_STATUS.COMPLETE);
                                let route = 'view-document';
                                if (newNotification.additionalProperties && newNotification.additionalProperties.folderType && newNotification.additionalProperties.folderType == 'RESOURCE_LIBRARY') {
                                    route = 'view-rl-document';
                                }
                                $(toastClass).parents('.ecv-toast-doc').click(function () {
                                    $_snack.clearNotificationToastr(toastId);
                                    $state.go('documents-load', {
                                        action: route,
                                        stateParams: {
                                            documentId: newNotification.entityId,
                                            folderId: s.documentFolderId,
                                            assignor: '',
                                            regeneratedSummary: null
                                        }
                                    });
                                });
                            }
                            if (s != "other") {
                                if (_.includes(["DOCUMENT", "LINK"], newNotification.entity)) {
                                    if (newNotification.event == "CREATE") {
                                        updatePost = false;
                                        if (newNotification.silent) {
                                            BroadcastService.broadcast('document-uploaded', [newNotification.entityId]);
                                        }
                                        BroadcastService.broadcast('update-document-metadata', [newNotification.entityId, { documentUsers: s.documentUsers }, false]);
                                    } else if (newNotification.event == "TITLE_CHANGED") {
                                        BroadcastService.broadcast('document-updates', [newNotification.entityId]);
                                        BroadcastService.broadcast('folder-document-updates', [newNotification.entityId, { additionalProperties: newNotification.additionalProperties }]);
                                    } else if (newNotification.event == "SHARE") {
                                        if (newNotification.status == "FAIL") {
                                            BroadcastService.broadcast('update-document-metadata', [newNotification.entityId, { documentUsers: s.documentUsers }, false]);
                                        } else {
                                            BroadcastService.broadcast('document-updates', [newNotification.entityId]);
                                            BroadcastService.broadcast('folder-document-updates', [newNotification.entityId]);
                                        }
                                    }
                                    else {
                                        BroadcastService.broadcast('document-updates');
                                        BroadcastService.broadcast('folder-document-updates', [newNotification.entityId]);
                                    }
                                    folderUpdated(s, FOLDER_MODULES.DOCUMENT);
                                }
                                else if (newNotification.entity == "FORM-DOCUMENT") {
                                    BroadcastService.broadcast('document-updates');
                                    BroadcastService.broadcast('folder-document-updates', [s.ids]);
                                    folderUpdated(s, FOLDER_MODULES.DOCUMENT);
                                }
                                else if (newNotification.entity == "FAX") {
                                    updatePost = false;
                                    BroadcastService.broadcast('document-updates');
                                    BroadcastService.broadcast('folder-document-updates', [s.ids]);
                                    folderUpdated(s, FOLDER_MODULES.DOCUMENT);
                                }
                                else if (newNotification.entity == "DISCUSSION") {
                                    if (newNotification.event == "TITLE_CHANGED") {
                                        BroadcastService.broadcast('folder-document-updates', [newNotification.entityId, { additionalProperties: newNotification.additionalProperties }]);
                                    } else {
                                        BroadcastService.broadcast('folder-document-updates', [newNotification.entityId]);
                                    }
                                    BroadcastService.broadcast('discussion-updates', [s.id]);
                                    folderUpdated(s, FOLDER_MODULES.DISCUSSION);
                                }
                                else if (newNotification.entity == "COMMENT") {
                                    BroadcastService.broadcast('discussion-updates', [s.id]);
                                    BroadcastService.broadcast('folder-document-updates', [s.id]);
                                    folderUpdated(s, FOLDER_MODULES.DISCUSSION);
                                } else if (newNotification.entity == "SIGNATURE") {
                                    BroadcastService.broadcast('update-document-metadata', [newNotification.parentEntityId, { signStatus: s.signStatus }, false]);
                                    if (newNotification.event == "ASSIGNED" || (newNotification.event == "SIGNED" && this.currentUser.id != newNotification.additionalProperties.ASSIGNEE)) {
                                        BroadcastService.broadcast('document-updates', [newNotification.parentEntityId]);
                                        BroadcastService.broadcast('folder-document-updates', [newNotification.parentEntityId]);
                                    }
                                    if (newNotification.event == "SIGNED" && this.currentUser.id == newNotification.additionalProperties.ASSIGNEE) {
                                        updatePost = false;
                                    }
                                    folderUpdated(s, FOLDER_MODULES.DOCUMENT);
                                }
                                if (!!updatePost) {
                                    BroadcastService.broadcast('post-updates');
                                }
                            }
                            deferred.resolve();
                        } catch (err) {
                            console.log("PS :: ", err);
                            deferred.reject();
                        }
                    }, (e) => {
                        context.addNotificationToCache(newNotification);
                        deferred.reject();
                    });
                }
            } catch (e) {
                console.log(e);
                deferred.reject();
            }
            return deferred.promise;
        }

        this.dltNtfctnsOnFrmDlt = (entityId) => {
            //reset the notification list after deleting forms to get the proper count.
            BroadcastService.broadcast('reset-notifications');
            //Reset the notification panel
            BroadcastService.broadcast('mark-notification-deleted');
            //Clear the notifications from bottom tray as well
            $_snack.removeSnackbar('entity-' + entityId);
        };

        this.deleteDocumentNotification = (id: number) => {
            //reset the notification list after deleting documents/discussions to get the proper count.
            BroadcastService.broadcast('reset-notifications');
            //Reset the notification panel
            BroadcastService.broadcast('mark-notification-deleted');
            //Clear bottom tray
            let toastClass = '.' + UPL_TOASTID_PREFIX + id;
            let toast = $(toastClass);
            if (!!toast.length) {
                let toastId = $(toastClass).attr('id');
                $_snack.clearNotificationToastr(toastId);
            }
            //////////////
        }

        this.deleteFormNotifications = (entityId: number): void => {
            //reset the notification list after deleting forms to get the proper count.
            BroadcastService.broadcast('reset-notifications');
            //Reset the notification panel
            BroadcastService.broadcast('mark-notification-deleted');
            //Clear the form-review notification from bottom tray as well
            $_snack.removeSnackbar('entity-' + entityId);
        }


        this.markNotificationInCache = (filterFunc) => {
            if (!!filterFunc && typeof filterFunc == "function") {
                let pushNotifications = CacheService.getPushNotifications();
                if (!!pushNotifications) {
                    let fltrdNoti = pushNotifications.filter(filterFunc);
                    CacheService.setPushNotifications(fltrdNoti);
                    BroadcastService.broadcast('update-notifications');
                }
            }
        }


        /**
         * Mark single notification as read in the backend and update the cache.
         */
        this.markNotificationAsRead = (filterFunc?, notification?, filters?) => {
            let updateNotifications = [];
            let payload = {};

            if (filters) {
                payload['filter'] = filters;
            }

            let notificationParams = {
                "id": notification.id,
                "delivered": true,
                "notificationType": 'PUSHNOTIFICATION'
            };
            updateNotifications.push(notificationParams);
            payload['updateNotifications'] = updateNotifications;
            ApiAdapterService.updateNotificationFlags(payload).then((c) => {
                if (notification.event == "SHARE" && _.includes(['DOCUMENT', 'DISCUSSION'], notification.entity)) {
                    $_document.updateEntityViewed(notification.entity, notification.entityId, true);
                }
                this.updateTotalCnt(-1);
                this.markNotificationInCache(filterFunc);
                BroadcastService.broadcast('mark-notification-read', [notification]);
            },
                (error) => {
                    if (error.toLowerCase() === "notification not found") {
                        console.log(error);
                        this.updateTotalCnt(-1);
                        this.markNotificationInCache(filterFunc);
                    }
                });
        }

        /**
         * Mark all notifications as read in the backend and update the cache.
         */
        this.markAllNotificationAsRead = (params, filterFunc?, filters?) => {
            let updateNotifications = [];
            let payload = {};

            if (filters) {
                payload['filter'] = filters;
            }
            let notificationParams = {
                "delivered": true,
                "notificationType": 'PUSHNOTIFICATION'
            };
            params.forEach((p) => {
                let obj = Object.assign({}, notificationParams, p);
                updateNotifications.push(obj);
            })
            payload['updateNotifications'] = updateNotifications;
            ApiAdapterService.updateNotificationFlags(payload).then((counts) => {
                let updCnt = counts.reduce((sum, cnt) => {
                    return sum + cnt;
                });
                if (!!updCnt) {
                    this.updateTotalCnt(updCnt * -1);
                }
                this.markNotificationInCache(filterFunc);
                BroadcastService.broadcast('mark-all-notifications-read');
            });
        }

        this.markNotificationAsDeleted = (params, filterFunc?, filters?) => {
            let updateNotifications = [];
            let payload = {};

            if (filters) {
                payload['filter'] = filters;
            }

            let notificationParams = {
                "deleted": true,
                "notificationType": 'PUSHNOTIFICATION'
            };
            params.forEach((p) => {
                let obj = Object.assign({}, notificationParams, p);
                updateNotifications.push(obj);
            })
            payload['updateNotifications'] = updateNotifications;
            ApiAdapterService.updateNotificationFlags(payload).then((counts) => {
                // if the notification is deleted from read list of the notification panel,
                // then no need to update the count and cache.
                if (filterFunc != null) {
                    let updCnt = counts.reduce((sum, cnt) => {
                        return sum + cnt;
                    });
                    if (!!updCnt) {
                        this.updateTotalCnt(updCnt * -1);
                    }
                }
                this.markNotificationInCache(filterFunc);
                BroadcastService.broadcast('mark-notification-deleted');
            });
        }

        this.updateFeeds = (notification: any): any => {
            var deferred = $q.defer();
            var newDoc;
            var type = "";
            var isComment = false;
            var currSubject = CacheService.getCurrentSubject();
            var documentId = 0;
            let password = CacheService.getPassword();
            if (_.includes(["DOCUMENT", "LINK", "DISCUSSION"], notification.entity)) {
                // Check if the notification is not related to a 'DELETE' event for a 'DISCUSSION' entity.
                // If it's any other notification, trigger the 'update-refresh-icon' broadcast event.
                if (notification.entity !== "DISCUSSION" || notification.event !== "DELETE") {
                    BroadcastService.broadcast('update-refresh-icon');
                }
                documentId = notification.entityId;
            } else if (notification.entity == "COMMENT" || notification.entity == "SIGNATURE") {
                BroadcastService.broadcast('update-refresh-icon');
                documentId = notification.parentEntityId;
            }
            if (notification.entity == "FAX" || notification.entity == "FORM-DOCUMENT") {
                let ids = notification.additionalProperties.DOCIDS;
                let docIdsArr = ids.split(',');
                $_caching.getDocuments(docIdsArr, '').then((docs) => {
                    $_caching.getDiscussionObjects(docs).then(s => {
                        type = "documents";
                        if (!!currSubject && (currSubject.subjectId != notification.subjectId)) {
                            FeedService.updateFeedInLocalCache(s, type, false, false).then((s) => {
                                deferred.resolve("other");
                            }).catch((err) => {
                                console.error("updateFeeds :: FAX/FORM-DOCUMENT updateFeedInLocalCache error:", err);
                                deferred.reject(err);
                            });
                        } else {
                            FeedService.updateFeedInLocalCache(s, type, false, true).then((success) => {
                                FeedService.updateFeedInLocalCache(s, 'posts', false, true).then((success) => {
                                    deferred.resolve({ ids: docIdsArr, lastActionTime: s[0].lastActionTime, documentFolderId: s[0].documentFolderId });
                                }).catch((err) => {
                                    console.error("updateFeeds :: FAX/FORM-DOCUMENT posts cache error:", err);
                                    deferred.reject(err);
                                });
                            }).catch((err) => {
                                console.error("updateFeeds :: FAX/FORM-DOCUMENT feed cache error:", err);
                                deferred.reject(err);
                            });
                        }
                    }).catch((err) => {
                        console.error("updateFeeds :: FAX/FORM-DOCUMENT getDiscussionObjects error:", err);
                        deferred.reject(err);
                    });
                }).catch((err) => {
                    console.error("updateFeeds :: FAX/FORM-DOCUMENT getDocuments error:", err);
                    deferred.reject(err);
                })
            }
            else {
                let folderType;
                notification.additionalProperties && (folderType = notification.additionalProperties.folderType);
                let filter = {
                    documentTypes: ["DOCUMENT", "DISCUSSION"],
                    addComments: true,
                };
                if (notification.entity == PostTypeEnums.LINK) {
                    filter["linkIds"] = [documentId];
                } else {
                    filter["documentIds"] = [documentId];
                }
                if (!!folderType) {
                    filter["folderType"] = folderType;
                }
                if (documentId > 0) {
                    ApiAdapterService.getPostsV2(CacheService.getPassword(), 0, 10, filter, null).then((s: any) => {
                        $_caching.getDiscussionObjects(s.posts).then(docs => {
                            newDoc = docs[0];
                            if (!!newDoc) {
                                newDoc.documentType = 'DOCUMENT';
                                newDoc.ownerId = newDoc.owner.id;
                                newDoc.documentId = newDoc.id;
                                newDoc.discussionId = newDoc.id;


                                if (newDoc.subjectId) {
                                    if (_.includes(["DOCUMENT"], notification.entity) && notification.event == "CREATE") {
                                        let cacheDocs = $_caching.getCachedFeeds()['documents'];
                                        let cacheDoc = cacheDocs.find(findDoc => findDoc.id == newDoc.id);
                                        if (!!cacheDoc) {
                                            for (let user of cacheDoc.documentUsers) {
                                                let existingUser = newDoc.documentUsers.find(findUser => findUser.id == user.id);
                                                if (!existingUser) {
                                                    newDoc.documentUsers.push(user);
                                                }
                                            }
                                        }
                                    }

                                    SubjectService.getSubjectById(newDoc.subjectId).then(subject => {
                                        newDoc.subject = subject || CacheService.getCurrentSubject();
                                        if (_.includes(["DOCUMENT", "LINK", "SIGNATURE"], notification.entity)) {
                                            type = "documents";
                                        } else if (notification.entity == "COMMENT" || (notification.entity == "DISCUSSION" && notification.event == "SHARE")) {
                                            isComment = true;
                                            type = "discussions";
                                            newDoc.commentsCount = newDoc.comments.length;
                                        } else if (notification.entity == "DISCUSSION") {
                                            type = "discussions";
                                        }
                                        if (!!currSubject && (currSubject.subjectId != notification.subjectId)) {
                                            FeedService.addOrUpdateCachedFeedIds([newDoc], type, true).then((s) => {
                                                deferred.resolve("other");
                                            }).catch((err) => {
                                                console.error("updateFeeds :: addOrUpdateCachedFeedIds (other subject) error:", err);
                                                deferred.reject(err);
                                            });
                                        } else {
                                            setTimeout(() => {
                                                FeedService.addOrUpdateCachedFeedIds([newDoc], type, true).then((s) => {
                                                    if (_.includes(["DOCUMENT"], notification.entity) && notification.event == "CREATE") {
                                                        deferred.resolve(newDoc);
                                                    } else {
                                                        FeedService.addOrUpdateCachedFolderFeedIds([newDoc], newDoc.documentFolderId, true).then(() => {
                                                            FeedService.addOrUpdateCachedFeedIds([newDoc], 'posts', true).then((s) => {
                                                                deferred.resolve(newDoc);
                                                            }).catch((err) => {
                                                                console.error("updateFeeds :: posts addOrUpdateCachedFeedIds error:", err);
                                                                deferred.reject(err);
                                                            });
                                                        }).catch((err) => {
                                                            console.error("updateFeeds :: addOrUpdateCachedFolderFeedIds error:", err);
                                                            deferred.reject(err);
                                                        });
                                                    }
                                                }).catch((err) => {
                                                    console.error("updateFeeds :: addOrUpdateCachedFeedIds error:", err);
                                                    deferred.reject(err);
                                                });
                                            }, 100);
                                        }
                                    }).catch((err) => {
                                        console.error("updateFeeds :: getSubjectById error:", err);
                                        deferred.reject(err);
                                    });
                                } else {
                                    setTimeout(() => {
                                        FeedService.addOrUpdateCachedFeedIds([newDoc], "documents", true).then((s) => {
                                            deferred.resolve(newDoc);
                                        }).catch((err) => {
                                            console.error("updateFeeds :: addOrUpdateCachedFeedIds (no subject) error:", err);
                                            deferred.reject(err);
                                        });
                                    }, 100);
                                }
                            } else {
                                // Document not found in response - resolve to prevent promise from hanging
                                console.warn("updateFeeds :: Document not found in API response for entityId:", notification.entityId);
                                deferred.resolve("not-found");
                            }
                        }).catch((err) => {
                            console.error("updateFeeds :: getDiscussionObjects error:", err);
                            deferred.reject(err);
                        });
                    }, (e) => {
                        console.log(e);
                        deferred.reject(e);
                    });
                } else {
                    // documentId is 0 or invalid - resolve immediately to prevent promise from hanging
                    console.warn("updateFeeds :: Invalid documentId:", documentId, "for notification entity:", notification.entity);
                    deferred.resolve("invalid-id");
                }
            }
            return deferred.promise;

        }

        this.openEntity = (notification: any, isNotificationActive = true) => {
            var deferred = $q.defer();
            var func = function (n) {
                return n.id != notification.id
            }
            if (isNotificationActive) {
                this.markNotificationAsRead(func, notification);
            }
            //If no CR selected or CR selected is not the CR the notification is for
            if (!!notification.subjectId) {

                ApiAdapterService.getSubjectsById([notification.subjectId]).then(
                    s => {
                        let sub: Subject = s[0];
                        $rootScope.selectChild(sub || -1).then((s) => {
                            BroadcastService.broadcast('cr-selected');
                        });

                        setTimeout(() => {
                            if (notification.entity == "COMMENT") {
                                $state.go("discussions-load", {
                                    action: "discussion-board-comment",
                                    stateParams: {
                                        discussion: notification.parentEntityId,
                                        comment: notification.entityId
                                    }
                                });
                            } else if (notification.entity == "TEAM_INVITATION" || notification.entity == "TEAM" || notification.entity == "DASHBOARD") {
                                //Clear the notifications from bottom tray as well
                                // In case of team created on-half-of captain
                                if (notification.event == "ON_BEHALF_OF") {
                                    let toastId = "team-" + notification.subjectId;
                                    $_snack.clearNotificationToastr(toastId);
                                }
                                $state.go('parent-dashboard', { team: notification.entityId });
                            } else if (_.includes(["TEAM_MEMBER", "ORG"], notification.entity)) {
                                $state.go('parent-dashboard', { team: notification.subjectId });
                            } else if (notification.entity == "DISCUSSION") {
                                if (notification.event == "PRE_SHARE") {
                                    $state.go("discussions-load",{action:"discussion-board-list",stateParams:{}},{reload:true});
                                } else {
                                    $state.go('discussions-load', {
                                        action: "discussion-board-discuss",
                                        stateParams: {
                                            discussion: notification.entityId
                                        }
                                    });
                                }
                            } else if (notification.entity == "FORM-ASSIGNED") {
                                if (notification.event == "REMINDER" && !!notification.additionalProperties && !!notification.additionalProperties.currentUserAdmin) {
                                    FormService.viewForm(notification.entityId, 0, 'asfr', null, true);
                                } else {
                                    FormService.fillForm(notification.entityId, 'asf', null, true);
                                }
                            } else if (notification.entity == "FORM") {
                                if (notification.event == 'UNASSIGN') {
                                    FormService.manageForms('assignedForms', null, true);
                                }
                            } else if (notification.entity == "FORM-DELETED") {
                                FormService.manageForms('assignedForms', null, true);
                            } else if (notification.entity == "FORM-SUBMITTED") {
                                FormService.viewForm(0, notification.entityId, 'cmpf', null, true);
                            } else if (notification.entity == "FORM-SUBMITTED-TRAY") {
                                var additionalProperties = notification.additionalProperties;
                                $_snack.clearNotificationToastr(notification.id);
                                if (notification.event == 'REDIRECT') {
                                    FormService.manageForms('availableForms', null, true);
                                } else if (notification.event == 'FORM-REVIEW') {
                                    FormService.viewForm(0, notification.entityId, 'cmpf', null, true);
                                } else {
                                    $state.go('view-report', { reportData: btoa(JSON.stringify(additionalProperties)) });
                                }
                            } else if (notification.entity == "FORM-WORKFLOW") {
                                var additionalProperties = notification.additionalProperties;
                                $_snack.clearNotificationToastr('workflow-' + notification.id);
                                if (notification.event == 'BEGIN_DETERMINATION') {
                                    if (!!additionalProperties && additionalProperties.crntUserProvider) {
                                        FormService.fillForm(notification.entityId, 'asf', null, true);
                                    } else {
                                        FormService.viewForm(notification.entityId, 0, 'asfr', null, true);
                                    }
                                } else if (notification.event == 'ASSIGN_SERVICE') {
                                    if (!!additionalProperties && additionalProperties.serviceCreated) {
                                        this.ServiceManager.viewCurrentService( notification.entityId, false);
                                    } else {
                                        FormService.viewForm(0, notification.entityId, 'cmpf', null, true);
                                    }
                                } else if (notification.event == 'WORKFLOW_ERROR') {
                                    FormService.viewForm(0, notification.entityId, 'cmpf', null, true);
                                }
                            } else if (_.includes(["DOCUMENT", "LINK"], notification.entity)) {
                                if (notification.status == "FAIL" && notification.event != "SHARE") {
                                    $state.go('organize')
                                } else if (notification.event == "PRE_SHARE") {
                                    $state.go('documents-load', { action: 'list-document', stateParams: { subjectId: notification.subjectId } }, { reload: true });
                                } else if (notification.entity == PostTypeEnums.LINK) {
                                    let route = 'view-document';
                                    if (notification.additionalProperties && notification.additionalProperties.folderType && notification.additionalProperties.folderType == 'RESOURCE_LIBRARY') {
                                        route = 'view-rl-document';
                                    }
                                    $state.go('documents-load', { action: route, stateParams: { documentId: notification.entityId, postType: PostTypeEnums.LINK, regeneratedSummary: null } });
                                } else {
                                    let route = 'view-document';
                                    if (notification.additionalProperties && notification.additionalProperties.folderType && notification.additionalProperties.folderType == 'RESOURCE_LIBRARY') {
                                        route = 'view-rl-document';
                                    }
                                    $state.go('documents-load', { action: route, stateParams: { documentId: notification.entityId, assignor: '', regeneratedSummary: null } });
                                }
                            } else if (notification.entity == "FAX" || notification.entity == "FORM-DOCUMENT") {
                                $state.go('documents-load', { action: 'list-document', stateParams: { folderId: notification.additionalProperties.folderId } }, { reload: true });
                            } else if (notification.entity == "SIGNATURE") {
                                if (notification.event == 'PENDING') {
                                    $state.go('parent-dashboard', { team: notification.subjectId }, { reload: true });
                                } else {
                                    $state.go('documents-load', { action: 'view-document', stateParams: { documentId: notification.parentEntityId, assignor: notification.additionalProperties.ASSIGNOR, signatureEvent: notification.event } });
                                }
                            }
                            deferred.resolve();
                        }, 300);
                    },
                    err => {
                        // TODO Fill out error logic
                        deferred.reject();
                    }
                );
            } else {
                setTimeout(() => {
                    if (notification.entity == "SERVICE") {
                        CacheService.setIsServicesAssigned(true);
                        BroadcastService.broadcast('update-services-assigned', [true]);
                        if (notification.event == 'ASSIGN' || notification.event == 'UPDATE') {
                            this.ServiceManager.viewCurrentService(notification.entityId, false);
                        } else {
                            this.ServiceManager.manageServices('currentServices', true);
                        }
                    } else if (notification.entity == "SERVICENOTE") {
                        CacheService.setIsServicesAssigned(true);
                        BroadcastService.broadcast('update-services-assigned', [true]);
                        $rootScope.openServiceNote = true;
                        this.ServiceManager.viewCurrentServiceNote(notification.entityId, notification.parentEntityId, false);
                    }
                    deferred.resolve();
                }, 0);
            }
            return deferred.promise;
        }
    }
}


angular.module('eCareVault.common.services')
    .service('PushNotificationService', PushNotificationService);
